import React from "react";
import PropTypes from "prop-types";
import Tooltip from "@material-ui/core/Tooltip";
import A_IconButton from "../../../Atoms/Inputs/Buttons/A_IconButton";
import useStyles from "./ProfessionalContacts.styles";

const IconAction = ({ title, ariaLabel, icon, onClick, danger, disabled }) => {
  const classes = useStyles();
  return (
    <Tooltip title={title}>
      <span>
        <A_IconButton
          size="small"
          color="inherit"
          className={danger ? classes.iconActionDanger : classes.iconAction}
          icon={icon}
          ariaLabel={ariaLabel || title}
          disabled={disabled}
          onClick={onClick}
        />
      </span>
    </Tooltip>
  );
};

IconAction.propTypes = {
  title: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
  icon: PropTypes.element.isRequired,
  onClick: PropTypes.func.isRequired,
  danger: PropTypes.bool,
  disabled: PropTypes.bool,
};

IconAction.defaultProps = {
  danger: false,
  disabled: false,
};

export default IconAction;
